"use strict";

exports.__esModule = true;
exports.createBalanceStorages = exports.PolkadotBalanceAdapter = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _operators = require("rxjs/operators");
var _storage = require("../../utils/storage");
var _errors = require("../../wallet/errors");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createBalanceStorages = api => {
  return {
    balances: address => _storage.Storage.create({
      api: api,
      path: 'derive.balances.all',
      params: [address]
    })
  };
};
exports.createBalanceStorages = createBalanceStorages;
class PolkadotBalanceAdapter {
  constructor(_ref) {
    let {
      api
    } = _ref;
    this.storages = void 0;
    this.decimals = void 0;
    this.ed = void 0;
    this.nativeToken = void 0;
    this.storages = createBalanceStorages(api);
    this.decimals = api.registry.chainDecimals[0];
    this.ed = _sdkCore.FixedPointNumber.fromInner(api.consts.balances.existentialDeposit.toString(), this.decimals);
    this.nativeToken = api.registry.chainTokens[0];
  }
  subscribeBalance(token, address) {
    const storage = this.storages.balances(address);
    if (token !== this.nativeToken) throw new _errors.CurrencyNotFound(token);
    return storage.observable.pipe((0, _operators.map)(data => ({
      free: _sdkCore.FixedPointNumber.fromInner(data.freeBalance.toString(), this.decimals),
      locked: _sdkCore.FixedPointNumber.fromInner(data.lockedBalance.toString(), this.decimals),
      reserved: _sdkCore.FixedPointNumber.fromInner(data.reservedBalance.toString(), this.decimals),
      available: _sdkCore.FixedPointNumber.fromInner(data.availableBalance.toString(), this.decimals)
    })));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getED(_token) {
    return this.ed;
  }
}
exports.PolkadotBalanceAdapter = PolkadotBalanceAdapter;